<template>
    <section class="noticias" id="acao">

        <div class="container">
            
            <div class="row">

                <div class="col-12 col-md-9 destaque"> 

                    <div v-if="noticia.Titulo">

                        <router-link :to=" { name : 'acao', params: { slug: noticia.Link } } ">

                            <!--<img :src="$sdk.prefix_images + noticia.Capa" class="cover" />-->

                            <h1>{{ noticia.Titulo }}</h1>

                            <div class="html" v-html="noticia.Texto"></div>

                        </router-link>
                    
                    </div>

                </div>

                <div class="col-12 col-md-3 sidebar">
                    
                    <main>

                        <div class="noticia" v-for="(noticia, noticiaIndex) in noticias" :key="noticiaIndex">
                            <router-link :to=" { name : 'acao', params: { slug: noticia.Link } } " @click.native="$router.go()">
                                <div class="thumb" :style="{ 'background-image' : 'url(' + $sdk.prefix_images + noticia.Capa + ')' }">
                                </div>
                                <span>{{ noticia.Titulo }}</span>
                            </router-link>
                        </div>

                    </main>
                    
                </div>

            </div>
        </div>

    </section>
</template>

<script>

export default {
    
    data() {
        return {
            noticia: {},
            noticias: [],
            errorMessage: null,
            s: null
        }
    },

    mounted: function(){

        this.carregar();

    },

    methods: {

        carregar: function(){

            var $this = this;

            $this.$sdk.get('acoes', function(ret){


                ret.forEach(noticia => {


                    //verifica se tem Youtube
                    const regex = /http[s]?:\/\/[w]?[w]?[w]?\.?youtube\.com\/watch\?v=([A-Za-z0-9]+)/gm;
                    const subst = `<div class="videoWrapper"><iframe width="560" height="315" src="https://www.youtube.com/embed/$1?title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;

                    noticia.Texto = noticia.Texto.replace(regex, subst);

                    if(noticia.Link == $this.$route.params.slug)
                        $this.noticia = noticia;
                    else
                        $this.noticias.push(noticia);

                });

            })
        }

    }

}
</script>